import createReducer from '../utils/createReducer';
import {
  PHONE_VALIDATION_PRESETS_REQUEST,
  PHONE_VALIDATION_PRESETS_FAILURE,
  PHONE_VALIDATION_PRESETS_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [PHONE_VALIDATION_PRESETS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [PHONE_VALIDATION_PRESETS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [PHONE_VALIDATION_PRESETS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/phoneValidationPresets.js